module.exports = __webpack_public_path__ + "public/Icons/driverAvatar.svg?861c44f7";